import { registerGroup, registerImage, registerRect, registerText } from "@visactor/vrender-kits";

export function loadCheckBoxComponent() {
    registerGroup(), registerRect(), registerText(), registerImage();
}
//# sourceMappingURL=register.js.map